/**
 * Fait défiler la vue vers un événement spécifique avec effet visuel
 * @param {string|number} eventId - L'ID de l'événement
 * @param {number} delay - Délai avant le défilement (ms)
 */
export function scrollToEvent(eventId, delay = 100) {
  setTimeout(() => {
    const eventElement = document.querySelector(`[data-id="${eventId}"]`);
    if (eventElement) {
      eventElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Ajouter un effet visuel temporaire
      eventElement.classList.add('highlighted');
      setTimeout(() => {
        eventElement.classList.remove('highlighted');
      }, 3000);

    }
  }, delay);
}

/**
 * Fait défiler vers un élément quelconque avec effet visuel
 * @param {string} selector - Sélecteur CSS de l'élément
 * @param {string} highlightClass - Classe CSS pour l'effet visuel
 */
export function scrollToElement(selector, highlightClass = 'highlighted') {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    if (highlightClass) {
      element.classList.add(highlightClass);
      setTimeout(() => {
        element.classList.remove(highlightClass);
      }, 3000);
    }
  }
}